export enum TableEventTargetType {
    HEADER = 'HEADER',
    DATA_ROW = 'DATA_ROW'
}
